import React from 'react';
import { Route, Redirect } from 'react-router-dom';
import auth from '../../../services/authService';
import './ProtectedRoute.scss';

export const ProtectedRoute = ({
  level,
  allow,
  path,
  component: Component,
  render,
  ...rest
}) => {
  return (
    <Route
      {...rest}
      render={(props) => {
        // allow grants access to users outside level (e.g. an agency master)
        const hasAccess =
          level.some((l) => l === auth.getUserType()) || !!allow?.();
        if (!hasAccess && auth.getToken()) {
          return <Redirect to="/not-found" />;
        }
        if (!auth.getToken()) {
          return <Redirect to="/" />;
        }
        return Component ? (
          <Component path={path} {...props} {...rest} />
        ) : (
          render(props)
        );
      }}
    />
  );
};
